import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files as JS modules
import { en } from './locales/en.js';
import { de } from './locales/de.js';
import { id } from './locales/id.js';
import { es } from './locales/es.js';
import { pt } from './locales/pt.js';
import { el } from './locales/el.js';
import { vi } from './locales/vi.js';

// Get saved language from localStorage or default to English
const savedLanguage = localStorage.getItem('appLanguage') || 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    id: { translation: id },
    es: { translation: es },
    pt: { translation: pt },
    el: { translation: el },
    vi: { translation: vi },
  },
  lng: savedLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;
